import * as actionTypes from "../actions/actionTypes.js";

const initialState = {
 user: {
     loggedIn:false,
     username: '',
     name: ""
 }
};

export default function authReducer(state = initialState, action) {

    if (action === undefined) {
        return state;
    }
    switch (action.type) {
        case actionTypes.LOGIN_SUCCESS :
            return Object.assign({}, state, {user: action.payload});
        case actionTypes.LOGOUT_SUCCESS :
            return Object.assign({}, state, {user: action.payload});
        default:
            return state;
    }
}
